<div class="customPanel">
  <h1 class="textM" style="text-align: center; height: 20%" mat-dialog-title>
    Start new Autotest - {{proyecto.nombre}}
  </h1>

  <div mat-dialog-content class="bodyForm" style="display: grid">
    Some functions of the luminaires of the proyect {{proyecto.nombre}} could be affected during the execution of the test
  </div>

  <div mat-dialog-actions style="height: 20%">
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("devices.cancel")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onStartClick()">Start</button>
    </div>
  </div>

</div>
